'use client'

import React, { useEffect } from 'react'

import Link from 'next/link'

type Props = {
  error: Error & { digest?: string }
  reset: () => void
}

// Deliberately self-contained (no UI-kit/styled-components imports): the
// boundary must not bloat the shared bundle for every route, and it still
// renders if theming/providers are what crashed. Body font/colors come from
// the global styles when available.
const STYLES: Record<string, React.CSSProperties> = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    minHeight: '100dvh',
    padding: '24px',
    textAlign: 'center',
  },
  button: {
    padding: '12px 24px',
    borderRadius: '12px',
    border: '1px solid transparent',
    backgroundColor: '#101828',
    color: '#ffffff',
    fontFamily: 'inherit',
    fontSize: '16px',
    cursor: 'pointer',
  },
  link: {
    color: 'inherit',
    fontSize: '16px',
  },
}

export default function Error({ error, reset }: Props) {
  useEffect(() => {
    // Surface the error for monitoring/console; no reporting layer exists.
    // eslint-disable-next-line no-console
    console.error(error)
  }, [error])

  return (
    <main style={STYLES.main}>
      <h1>Something went wrong</h1>

      <p>An unexpected error occurred while rendering this page.</p>

      <button style={STYLES.button} type="button" onClick={reset}>
        Try again
      </button>

      <Link href="/" style={STYLES.link}>
        Back to homepage
      </Link>
    </main>
  )
}
